module.exports = __webpack_public_path__ + "982f9dee46f14874dd39cb4049c82668.pdf";